import { AuthApi } from '../auth/authApi';
import { Singleton } from '@/decorators';
import {
  GetInviteStatusRequestDTO,
  GetInviteStatusResponseDTO,
  InviteProviderRequestDTO,
  InviteProviderResponseDTO,
} from './DTOs';
import type { Result } from '@/types/result.interface';
import type { AppError } from '@/types/errors.interface';
import { wrapHttpCall } from '../utils/apiResultMapper';

/**
 * Provider API (Framework Agnostic)
 * 
 * Handles provider invitation operations.
 */
@Singleton
export class ProviderApi extends AuthApi {
  constructor() {
    super();
  }

  async getInviteStatus(body: GetInviteStatusRequestDTO): Promise<Result<GetInviteStatusResponseDTO, AppError>> {
    return wrapHttpCall(() => this.api.get<GetInviteStatusResponseDTO>(
      `/ApplicationForm/${body.applicationId}/inviteStatus`,
    ));
  }

  async invite(body: InviteProviderRequestDTO): Promise<Result<InviteProviderResponseDTO, AppError>> {
    // The email travels in the body; URLs end up in telemetry and access logs.
    return wrapHttpCall(() => this.api.post<InviteProviderResponseDTO>(
      `/ApplicationForm/${body.applicationId}/inviteProvider`,
      { providerEmail: body.providerEmail },
    ));
  }
}
